import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import swal from 'sweetalert2';
import { UpdateLeadsService, SubscribeService } from '../../services/index';
import * as XLSX from 'xlsx';
import * as moment from 'moment';

@Component({
    selector: 'update-leads',
    templateUrl: './updateLeads.component.html',
})
export class UpdateLeadsComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    @ViewChild('fileUpload') fileUpload;

    isLoadMask: Promise<any>;
    excelData: any;
    rawFile: File = null;
    rawFileBase64: string = '';
    rawFileName: string = '';
    isLoading: boolean = false;
    leadsList = [];

    constructor(
        private updateLeadsService: UpdateLeadsService,
        public subscribeService: SubscribeService
    ) {
    }

    ngOnInit(): void {
    }

    openWindow() {
        this.fileUpload.click();
    }

    downloadFile() {
        const todayDate = moment().format('DD-MM-YYYY');
        const ws = XLSX.utils.aoa_to_sheet([
            ['Month', 'Date', 'Branch', 'Client ID', 'Name', 'Mobile', 'Address', 'CHANNEL', 'Doctor/Non Doctor', 'Source', 'SUB SOURCE', 'Campaign / Ad', 'Ha Model', 'Quantity', 'DESCRIPTION', 'Follow up Date', 'SUMMARY STATUS (FOLLOW UP / CALL DROP / DONE / NOT OK / WHATSAPP)', 'STATUS (HOT / WARM /COLD)', 'Ha price', 'Sold price', 'Sold/UnSold', 'Email', 'Description', 'Status', 'Telecaller name'],
            ['January', todayDate, 'Branch Name', '', 'John Doe', '9876543210', '123 Main Street, City', 'Online', 'Doctor', 'Facebook', 'FB Ads', 'Campaign Name', 'Premium HA', '1', 'Initial consultation required', todayDate, 'FOLLOW UP', 'HOT', '50000', '45000', 'UnSold', 'john@email.com', 'Follow up notes', 'Active', 'Sales Team'],
            ['February', todayDate, 'Branch Name', '', 'Jane Smith', '8765432109', '456 Oak Avenue, Town', 'Phone', 'Non Doctor', 'Google', 'Search Ads', 'Google Campaign', 'Standard HA', '2', 'Price comparison needed', todayDate, 'CALL DROP', 'WARM', '35000', '0', 'UnSold', 'jane@email.com', 'Callback scheduled', 'Pending', 'Call Center']
        ]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const fileName = 'Update_Leads_Sample_' + moment().format('DD-MM-YYYY_HH-mm') + '.xlsx';
        XLSX.writeFile(wb, fileName);
    }

    uploadFile(sheet) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        if ((sheet.target.files.length == 0) || (sheet.target.files.length < 0)) {
            return;
        }
        const file = sheet.target.files[0];
        this.rawFile = file;
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary', cellDates: true });
            console.log('Sheet Names:', workBook.SheetNames);
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            console.log('Number of sheets:', Object.keys(jsonData).length);
            console.log('Sheet data keys:', Object.keys(jsonData));

            // Find the first sheet with data
            let firstSheetWithData = null;
            let sheetData = null;

            for (const sheetName of Object.keys(jsonData)) {
                if (jsonData[sheetName] && jsonData[sheetName].length > 0) {
                    firstSheetWithData = sheetName;
                    sheetData = jsonData[sheetName];
                    break;
                }
            }

            if (firstSheetWithData && sheetData) {
                console.log('Using sheet:', firstSheetWithData, 'with', sheetData.length, 'rows');
                for (let j = 0; j < sheetData.length; j++) {
                    // Convert Date field
                    if (sheetData[j].Date && typeof sheetData[j].Date === 'object') {
                        sheetData[j].CONV_DATE = moment(sheetData[j].Date).format('DD-MM-YYYY');
                    } else if (sheetData[j].Date) {
                        sheetData[j].CONV_DATE = sheetData[j].Date;
                    } else {
                        sheetData[j].CONV_DATE = moment().format('DD-MM-YYYY');
                    }

                    // Convert Follow up Date field
                    if (sheetData[j]['Follow up Date'] && typeof sheetData[j]['Follow up Date'] === 'object') {
                        sheetData[j].CONV_FOLLOWUP_DATE = moment(sheetData[j]['Follow up Date']).format('DD-MM-YYYY');
                    } else if (sheetData[j]['Follow up Date']) {
                        sheetData[j].CONV_FOLLOWUP_DATE = sheetData[j]['Follow up Date'];
                    } else {
                        sheetData[j].CONV_FOLLOWUP_DATE = '';
                    }
                }
                // Restructure data to always use 'Sheet1' key for backend compatibility
                const restructuredData = { 'Sheet1': sheetData };
                this.excelData = JSON.stringify(restructuredData);
                this.leadsList = sheetData;
                this.rawFileName = file.name;
            } else {
                this.excelData = '';
                this.rawFile = null;
                this.rawFileName = '';
                sheet.srcElement.value = null;
                swal({ title: 'ERROR', text: 'No data found in any sheet. Please check your Excel file.', type: 'error' });
            }
        };
        reader.readAsBinaryString(file);
        this.fileUpload.nativeElement.value = '';
    }

    saveFile() {
        if (!this.excelData || this.leadsList.length === 0) {
            swal({ title: 'ERROR', text: 'Please upload an Excel file first', type: 'error' });
            return;
        }

        this.isLoading = true;
        const that = this;
        const params = {
            data: this.excelData
        };
        this.isLoadMask = this.updateLeadsService
            .saveUpdateLeadsData(params)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.excelData = '';
                    that.rawFile = null;
                    that.rawFileName = '';
                    that.leadsList = [];
                    swal({ title: 'Success', html: that.buildResultHtml(res.message, res.errors), type: 'success' });
                } else {
                    swal({ title: 'ERROR', html: that.buildResultHtml(res.message, res.errors), type: 'error' });
                }
            }).catch(() => {
                that.isLoading = false;
                swal({ title: 'ERROR', text: 'An error occurred while updating', type: 'error' });
            });
    }

    buildResultHtml(message: string, errors: string[]): string {
        let html = `<p style="margin-bottom:8px;">${message}</p>`;
        if (errors && errors.length > 0) {
            html += `<div style="max-height:300px;overflow-y:auto;text-align:left;border:1px solid #ddd;border-radius:4px;padding:6px 10px;">`;
            errors.forEach((err, i) => {
                html += `<div style="padding:5px 0;border-bottom:1px solid #eee;color:#dc3545;font-size:15px;font-weight:bold;">${i + 1}. ${err}</div>`;
            });
            html += `</div>`;
        }
        return html;
    }

    fileData() {
        if (!this.excelData) {
            return true;
        }
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/updateLeads.component.ts